module.exports = __webpack_public_path__ + "static/media/prev-page-pagination.5d39db25.svg";